// ref: https://github.com/chakra-ui/chakra-ui/tree/main/packages/theme/src/foundations

// Global style overrides
import styles from './styles'
// Foundational style overrides
import borders from './foundations/borders'
import colors from './foundations/colors'
import zIndices from './foundations/z-index'
// Component style overrides
import Alert from './components/alert'
import Badge from './components/badge'
import Button from './components/button'
import Checkbox from './components/checkbox'
import Input from './components/input'
import Link from './components/link'
import Select from './components/select'
import Switch from './components/switch'
import Tabs from './components/tabs'
import Modal from './components/modal'
import Table from './components/table'
import Popover from './components/popover'
import Accordion from './components/accordion'
import Avatar from './components/avatar'

const theme = {
  styles,
  borders,
  colors,
  zIndices,
  // Other foundational style overrides go here
  components: {
    Alert,
    Badge,
    Button,
    Checkbox,
    Input,
    Link,
    Select,
    Switch,
    Tabs,
    Modal,
    Table,
    Popover,
    Accordion,
    Avatar,
    // Other components go here
  },
  fonts: {
    heading: 'Poppins',
    body: 'Poppins',
  },
}

export default theme
